<template>
    <div class="detail">
        <!-- 1. 顶部标题栏 -->
        <detail-title-bar></detail-title-bar>
        <!-- 2. 命盘及tabbar部分 -->
        <div class="detail-main-panel">
            <fate-panel 
                v-bind:hideSideBar="false" 
                v-bind:fateData="detailFateListData" 
                v-bind:fateSideData="detailFateSideListData" 
                v-bind:siZhuLiuNianReverse="parseInt(settingConfigData.sizhuGeShi) == 1"
                v-bind:parentFrom="'detail'"
                v-bind:fateInfo="detailFateInfo"
                v-bind:sideCloseFunc="clickSideClose">
            </fate-panel>
            <div class="layout-df-side">
                <span v-show="personInfo.location != ''" class="layout-df-side-span" @click="clickRealSunTime">真</span>
            </div>
            <!-- 2.1 tab部分 -->
            <detail-tab-bar></detail-tab-bar>
        </div>

        <div class="detail-content">
            <!-- 3.1. 资料 -->
            <detail-infomation v-show="showDetailType == 0"></detail-infomation>
            <!-- 3.2.1 运盘 -->
            <fortune-panel 
                v-show="showDetailType == 1"
                v-bind:detailInfo="personInfo"
                v-bind:fortuneTitle="detailFortuneTitle"
                v-bind:fortuneData="detailFortuneData"
                v-bind:transitioned="true"
                v-bind:parentFrom="'detail'"
                v-bind:subTitle="detailSubTitle"
                v-bind:showType="detailShowType"
                v-bind:showTable="detailShowTable"
                v-bind:liunianData="detailLiunianData"
                v-bind:liuyueData="detailLiuyueData"
                v-bind:liuriData="detailLiuriData"
                v-bind:liushiData="detailLiushiData"
                v-bind:itemFunc="clickFortuneItem">
            </fortune-panel>
            <!-- 3.2.2 标签 -->
            <detail-label v-show="showDetailType == 1"></detail-label>
            <!-- 3.3. 神煞 -->
            <detail-shensha v-show="showDetailType == 2"></detail-shensha>
        </div>


        <!-- 4. 底部导航栏 -->
        <detail-bottom-bar v-if="!hideBottomBar"></detail-bottom-bar>

        <!-- 5. 二维码弹框 -->
        <div class="layout-overlay" v-if="showQrCodePop"></div>
        <div class="layout-popup detail-qrcode-pop" v-if="showQrCodePop">
            <qrcode class="qrcode-img" id='qrImg' tag="img" :options="{size: 300}" :value="qrCodeValue" ></qrcode>
            <i class="iconbg icon-qr-logo qrcode-icon"></i>
            <i class="iconfont icon-close qrcode-close" @click="clickCloseQrCode"></i>
        </div>

        <!-- 6. 说明弹框 -->
        <div class="layout-overlay" v-if="showRealSunTimePop" @click="clickRealSunTimeOverLay"></div>
        <div class="layout-popup detail-note-pop" v-if="showRealSunTimePop">
            <div class="detail-note-pop-title">
                <i class="iconfont icon-arrowflower-left detail-note-pop-icon"></i>
                <span>真太阳时说明</span>
                <i class="iconfont icon-arrowflower-right detail-note-pop-icon"></i>
            </div>
            <div class="detail-note-pop-content">
                <p>就是不同地点根据太阳位置计算出来的地方时间，相当于古人使用日晷测出的当地时间。</p>
                <p>古代测算八字都是严格以当地时间为准，而现代因为大家统一使用北京时间，实际与北京经度偏差越大的地方时辰偏差越大。</p>
                <p class="p-green">为了精准测算八字，大家尽量使用真太阳时，确定好命主的出生地点。</p>
            </div>
        </div>

        <!-- 7. 操作批盘论盘弹框 -->
        <div class="layout-overlay layout-overlay-blank" v-if="showPipanLunpanPop" @click="clickPiLunOverLay"></div>
        <detail-pi-lun-pop v-if="showPipanLunpanPop"></detail-pi-lun-pop>

        <!-- 8. 提示打开分享弹框 -->
        <div class="layout-overlay" v-if="showDetailSharePop" @click="clickShareOverlay"></div>
        <detail-share-pop v-if="showDetailSharePop"></detail-share-pop>

        <!-- 9. 八字详情提示弹框 -->
        <reminder-detail v-if="showDetailReminder"></reminder-detail>

        <!-- 10. 分享的八字详情提示弹框 -->
        <reminder-share v-if="showShareReminder"></reminder-share>

        <!-- 11. 天赋性格弹框 -->
        <nature-main-popup></nature-main-popup>

        <!-- 12. 保存日历八字弹框 -->
        <van-popup class="share-change-group-popup" :value=showCalendarChagnePop v-bind:close-on-click-overlay="false">
            <div class="share-cgpp-title">确定八字名称或分组</div>
            <div class="share-cgpp-item">
                <label class="collate-form-label cf-label-two">姓 名</label>
                <input class="collate-form-input" type="text" maxlength="15" placeholder="输入称呼" v-model="calendarFormData.f_name" autofocus>
            </div>
            <div class="share-cgpp-item" @click="chooseGroup">
                <label class="collate-form-label cf-label-two">分 组</label>
                <div class="share-cgpp-choose">
                    <span v-if="calendarFormData.group" class="share-cgpp-text-have">{{calendarFormData.group.slice(0, 10)}}</span>
                    <span v-else class="share-cgpp-text">选择分组</span>
                    <i class="cf-icon-right iconfont icon-xiangyou"></i>
                </div>
            </div>
            <div class="share-cgpp-button" @click="confirmChange">确定</div>
        </van-popup>

         <!-- 13. 重复八字过滤弹框 -->
        <van-popup v-bind:value="showSamePop" class="layout-same-select-pop-box" @click-overlay="clickSameSelectOverlay">
            <vant-same-select-pop
                v-bind:selectedList="recordSameEightWordList"
                v-bind:itemFunc="clickSameListItem"
                v-bind:saveFunc="clickSameSave">
            </vant-same-select-pop>
        </van-popup>

        <!-- 6. 新建对比弹框 -->
        <van-popup v-bind:value="showContrastCreatePanel" class="layout-contrast-create-pop-box" @click-overlay="clickContrastCreateOverlay">
            <vant-contrast-create-pop></vant-contrast-create-pop>
        </van-popup>


        <router-view></router-view>
    </div>
</template>

<script>
import DetailTitleBar from '../layouts/detail/DetailTitleBar.vue'
import FatePanel from '../layouts/panel/FatePanel.vue'
import FortunePanel from '../layouts/panel/FortunePanel.vue'
import DetailTabBar from '../layouts/detail/DetailTabBar.vue'
import DetailInfomation from '../layouts/detail/DetailInfomation.vue'
import DetailLabel from '../layouts/detail/DetailLabel.vue'
import DetailShensha from '../layouts/detail/DetailShensha.vue'
import DetailBottomBar from '../layouts/detail/DetailBottomBar.vue'
import DetailPiLunPop from '../layouts/detail/DetailPiLunPop.vue'
import DetailSharePop from '../layouts/detail/DetailSharePop.vue'
import ReminderDetail from '../layouts/reminder/ReminderDetail.vue'
import ReminderShare from '../layouts/reminder/ReminderShare.vue'
import NatureMainPopup from '../layouts/nature/NatureMainPopup.vue'
import VantSameSelectPop from '../layouts/vant/VantSameSelectPop.vue'
import VantContrastCreatePop from '../layouts/vant/VantContrastCreatePop.vue'
import { MIX } from '../modules/utils'
export default {
    name: 'Detail',
    components: { DetailTitleBar, FatePanel, FortunePanel, DetailTabBar, DetailInfomation, DetailLabel, DetailShensha, DetailBottomBar, DetailPiLunPop, DetailSharePop, ReminderDetail, ReminderShare, NatureMainPopup, VantSameSelectPop, VantContrastCreatePop },
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        personInfo() {
            return this.$store.state.detail.personInfo;
        },
        isLocalDetail() {
            return this.$store.state.detail.isLocalDetail;
        },
        hideBottomBar() {
            return this.$store.state.detail.hideBottomBar;
        },
        detailFateInfo(){
            return this.$store.state.detail.fatefortune.fateInfo
        },
        detailFateListData(){
            var detailFateListData = [].concat(this.$store.state.detail.fatefortune.fateListData);
                detailFateListData = parseInt(this.settingConfigData.nianyueRishi) == 0 ? detailFateListData : detailFateListData.reverse();
            return detailFateListData;
        },
        detailFateSideListData(){
            var detailFateSideListData = [].concat(this.$store.state.detail.fatefortune.fateSideListData);
                detailFateSideListData = parseInt(this.settingConfigData.nianyueRishi) == 0 ? detailFateSideListData : detailFateSideListData.reverse();
            return detailFateSideListData;
        },
        detailFortuneTitle() {
            return this.$store.state.detail.fatefortune.fortuneTitle;
        },
        detailFortuneData() {
            return this.$store.state.detail.fatefortune.fortuneListData;
        },
        detailSubTitle() {
            return this.$store.state.detail.fatefortune.subTitle
        },
        detailShowTable() {
            return this.$store.state.detail.fatefortune.showTable;
        },
        detailShowType() {
            return this.$store.state.detail.fatefortune.showType;
        },
        detailLiunianData() {
            return this.$store.state.detail.fatefortune.liunianListData;
        },
        detailLiuyueData() {
            return this.$store.state.detail.fatefortune.liuyueListData;
        },
        detailLiuriData() {
            return this.$store.state.detail.fatefortune.liuriListData;
        },
        detailLiushiData() {
            return this.$store.state.detail.fatefortune.liushiListData;
        },
        showDetailType() {
            return this.$store.state.detail.showDetailType
        },
        showQrCodePop() {
            return this.$store.state.detail.showQrCodePop
        },
        qrCodeValue() {
            return this.$store.state.detail.qrCodeValue
        },
        showPipanLunpanPop() {
            return this.$store.state.detail.showPipanLunpanPop
        },
        showDetailSharePop() {
            return this.$store.state.detail.showDetailSharePop
        },
        showDetailReminder() {
            return this.$store.state.reminder.showDetailReminder
        },
        showShareReminder() {
            return this.$store.state.reminder.showShareReminder
        },
        shareId() {
            return this.$store.state.share.shareId
        },
        calendarFormData() {
            return this.$store.state.calendar.calendarFormData
        },
        showCalendarChagnePop() {
            return this.$store.state.calendar.showCalendarChagnePop
        },
        showSamePop() {
            return this.$store.state.record.showSamePop;
        },
        recordSameEightWordList() {
            return this.$store.state.record.recordSameEightWordList;
        },
        showContrastCreatePanel() {
            return this.$store.state.contrast.showContrastCreatePanel;
        },
    },
    data(){
        return {
            clickLock: false,
            showRealSunTimePop: false
        }
    },
    beforeCreate: function() {
        // 滚动设置到初始值
        // document.documentElement.scrollTop = 0;
        // 容错处理
        if(location.pathname.indexOf('share') == -1 && !this.$store.state.detail.personInfo.id && !this.$store.state.detail.isLocalDetail){
            this.$router.replace('/record');
        }
    },
    mounted() {
        var me = this,
            curPath = this.$router.history.current.path,
            initTime = curPath.indexOf('share/detail') != -1 ? 1000 : 20;
        setTimeout(() => {
            me.initDom();
            me.initData();
            MIX.trackPageViewed('MingPanPage');
        }, initTime);
        setTimeout(() => {
            if(curPath.indexOf('share/detail') != -1) {
                this.$store.dispatch('reminder/checkShareExtTime');
            }else {
                this.$store.dispatch('reminder/checkDetailExtTime');
            }
        }, 2000);
        this.$bus.on('updateDetailDom', this.initDom);
    },
    destroyed() {
        this.$bus.off('updateDetailDom', this.initDom);
    },
    methods:{
        initDom() {
            var me = this;
            function setDom() {
                var titleDiv = document.getElementsByClassName("title-bar")[0];
                var barDiv = document.getElementsByClassName("detail-main-panel")[0];
                var menuDiv = document.getElementsByClassName('bottom-menu-bar')[0];
                var tabDiv = document.getElementsByClassName("layout-dft-title-box")[0];
                var contentDiv = document.getElementsByClassName("detail-content")[0];
                var height = titleDiv ? innerHeight - titleDiv.clientHeight : innerHeight;
                    height = me.$store.state.detail.hideBottomBar ? height+50 : height;
                    height = me.shareId != '' ? height+70 : height;
                    height = innerHeight <= 680 ? innerHeight*0.4 : innerHeight*0.35;
                var maxHeight = innerWidth >= 720 ? 380 : 220;
                var barH = height > maxHeight ? maxHeight : height;
                // 做一层容错
                if(contentDiv){
                    contentDiv.style.height = innerHeight+'px';
                    if(menuDiv) {
                        contentDiv.style.height = (innerHeight-menuDiv.clientHeight)+'px';
                    }
                    var paddingT = tabDiv ? tabDiv.clientHeight+barH : barH;
                    contentDiv.style.paddingTop = paddingT+'px';
                    contentDiv.style.paddingBottom = menuDiv ? menuDiv.clientHeight+'px' : '20px';
                }
                if(barDiv) {
                    barDiv.style.height = barH+'px';
                    barDiv.style.paddingTop = titleDiv.clientHeight+'px';
                }
            }
            setDom();
            
            // 解决输入框滚动之后，需要手动滚动的问题；
            var detailDiv = document.getElementsByClassName('detail')[0];
            if(detailDiv){
                detailDiv.scrollIntoView();
            }

            // 屏幕改变大小:旋转屏幕:重置高度
            window.onresize = function(){
                setTimeout(() => {
                    setDom();
                }, 20);
            }
            window.onorientationchange = function() {
                setTimeout(() => {
                    setDom();
                }, 20);
            }
            window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function(){
                setTimeout(() => {
                    setDom();
                }, 20);
            }, false);
        },
        initData() {
            if(this.isLocalDetail || this.hideBottomBar) { return; }
            var me = this;
            this.$store.dispatch('report/getAiCharacter', {
                detailInfo: me.personInfo,
                cb: function() {
                    me.$bus.emit('clearDetailNatureTime');
                    me.$bus.emit('updateDetailNatureTime');
                }
            });
        },
        clickCloseQrCode() {
            this.$store.state.detail.showQrCodePop = false;
        },
        clickRealSunTime() {
            this.showRealSunTimePop = true;
        },
        clickRealSunTimeOverLay() {
            this.showRealSunTimePop = false;
        },
        clickSideClose(data) {
            this.$store.dispatch("detail/fatefortune/deleteDetailFateSide", data);
        },
        clickFortuneItem(data) {
            // 增加点击时间的锁定
            if(this.clickLock) {
                return;
            }
            var me = this;
            setTimeout(() => {
                me.clickLock = false;
            }, 300);
            this.clickLock = true;

            // 增加命盘右侧数据
            this.$store.dispatch("detail/fatefortune/addDetailFateSide", data);
            switch (data.type) {
                case "dayun":
                    this.$store.dispatch("detail/fatefortune/showDetailLiuNian", data);
                    break;
                case "liunian":
                    this.$store.dispatch("detail/fatefortune/showDetailLiuYue", data.year);
                    break;
                case "liuyue":
                    this.$store.dispatch("detail/fatefortune/showDetailLiuRi", data.time);
                    break;
                case "liuri":
                    this.$store.dispatch("detail/fatefortune/showDetailLiuShi", data.g);
                    break;
                default:
                    break;
            }
        },
        clickPiLunOverLay() {
            this.$store.state.detail.showPipanLunpanPop = false;
        },
        clickShareOverlay() {
            this.$store.state.detail.showDetailSharePop = false;
        },
        clickRemiderOverlay() {
            console.log('clickRemiderOverlay');
            // this.$store.state.reminder.clickRemiderOverlay = false;
        },
        chooseGroup() {
            var curPath = this.$router.history.current.path;
            this.$router.replace(curPath+'/choosegroup');
        },
        confirmChange() {
            var me = this;
            var fromPage = this.$store.state.calendar.detailFromPage;
            this.$store.state.record.showSamePop = false;
            this.$store.dispatch('calendar/saveCalendarCollate', {
                cb: function(detailId){
                    me.$store.state.calendar.showCalendarChagnePop = false;
                    me.$router.replace('/detail/'+fromPage+'/' + detailId);
                    setTimeout(() => {
                        me.initDom();
                    }, 20);
                }
            });
        },
        clickSameSelectOverlay() {
            this.$store.state.record.showSamePop = false;
        },
        clickSameListItem(data) {
            var me = this,
                personInfo = this.$store.state.record.recordOriginalData[data.id];
            var fromPage = this.$store.state.calendar.detailFromPage;
            this.$store.state.record.showSamePop = false;
            this.$store.dispatch('detail/resetData');
            this.$store.dispatch('detail/initDetail', personInfo);
            this.$store.dispatch('record/updateRecordListData', personInfo);
            this.$router.replace('/detail/'+fromPage+'/'+ personInfo.id);
        },
        clickSameSave() {
            this.$store.state.record.showSamePop = false;
            this.$store.state.calendar.showCalendarChagnePop = true;
        },
        clickContrastCreateOverlay() {
            this.$store.state.contrast.showContrastCreatePanel = false;
        }
    }
}
</script>